import React from 'react'
import BillingManagement from '../containers/Billing/BillingManagement'
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers' 
 
const Parcels = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <BillingManagement/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Parcels
